import React, {useEffect, useState} from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import {useNavigate,Link} from "react-router-dom";
import axios from "axios";
import {defaultVariables} from "../../../config";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@mui/material/Grid2";
import AdminDashSkeleton from "../../components/loaders/AdminDashSkeleton";
import {useTranslation} from "react-i18next";
import {Box, Button, IconButton, Typography} from "@mui/material";
import {
    CircleArrowRight, CircleOff,
    ClipboardList,
    CreditCard,
    Eye,
    Loader,
    MessageCircle,
    MessageSquare,
    MoveRight,
    Store
} from "lucide-react";
import {currencySymbol, price, scrollTop} from "../../../config/values";
import { LineChart } from '@mui/x-charts/LineChart';
import moment from "moment";
import SwiperSlider from "../../components/elements/slider/SwiperSlider";
import SubTitle from "../../components/elements/SubTitle";
import Title from "../../components/elements/Title";
import StockPriceChart from "../manage/stocks/price/StockPriceChart";
import ProfitsChart from "../manage/stocks/profits/ProfitsChart";
import UserDashSkeleton from "../../components/loaders/UserDashSkeleton";
import RequestImg from "../../../files/img/icons/request.png";
import clsx from "clsx";
import {getDirection} from "../../../config/design/theme";

const UserDashboard = ({ classes,user,setting }) => {
    const { t } = useTranslation();
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([]);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/dashboards/get-user`,config)
            .then(response => {
                setData(response.data);
                console.log(response.data)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
        scrollTop();
    }, []);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('dashboard')}>
            <Grid container spacing={2} justify="center" className="dashboard">
                {
                    loading ?
                        <UserDashSkeleton/>
                        :
                        <>
                            <Grid item size={12}>
                                <Typography>{t("welcomeUser")}</Typography>
                            </Grid>
                            {/*<Grid item size={12}>
                                <Grid container spacing={2} style={{border:'1px solid #ddd', borderRadius:10,padding:15}}>
                                    <Grid item size={{xs:6,sm:6,md:4,lg:4}} className={classes.cardHelp}>
                                        <img src={RequestImg} alt='android-app' loading="lazy" width={60}/>
                                        <SubTitle style={{marginBottom:20}}><strong>{t('stockProfitChart')}</strong></SubTitle>
                                        <Typography>سلامسیشتبسخیبت مخهیبتسی خهشسیئو شسنیتش سیووهی ن</Typography>
                                    </Grid>
                                    <Grid item size={{xs:6,sm:6,md:4,lg:4}} className={classes.cardHelp}>
                                        <img src={RequestImg} alt='android-app' loading="lazy" width={60}/>
                                        <SubTitle style={{marginBottom:20}}><strong>{t('stockProfitChart')}</strong></SubTitle>
                                        <Typography>سلامسیشتبسخیبت مخهیبتسی خهشسیئو شسنیتش سیووهی ن</Typography>
                                    </Grid>
                                    <Grid item size={{xs:6,sm:6,md:4,lg:4}} className={classes.cardHelp} style={{borderLeft:'none'}}>
                                        <img src={RequestImg} alt='android-app' loading="lazy" width={60}/>
                                        <SubTitle style={{marginBottom:20}}><strong>{t('stockProfitChart')}</strong></SubTitle>
                                        <Typography>سلامسیشتبسخیبت مخهیبتسی خهشسیئو شسنیتش سیووهی ن</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>*/}



                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/bs-requests/view-all'>
                                    <ClipboardList className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center">{t('pending_requests')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_requests}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/installments/view-all'>
                                    <Loader className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('pending_installments')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_installments}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/installments/view-all'>
                                    <CreditCard className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('onGoing_installments')}</span>
                                    <strong style={{fontSize:20}}>{data.not_paid_installments}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/user/support'>
                                    <MessageSquare className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item text-center"> {t('unread_tickets')}</span>
                                    <strong style={{fontSize:20}}>{data.unread_tickets}</strong>
                                </Box>
                            </Grid>


                            <Grid item size={{xs:12,md:6}} className="bg-gray-box p-20">
                                <SubTitle><strong>{t('todayStocksPrice')}</strong></SubTitle>
                                <div className="flex-direction gap-0 flex-column-xs">
                                    <Box className="text-center stock-box">
                                        <Title>{t('normal')}</Title>
                                        <strong style={{fontSize:20}}>{price(setting.current_normal_price)} {currencySymbol}</strong>
                                    </Box>
                                    <Box className={clsx('text-center','stock-box', getDirection() === "rtl" ? 'brd-right' : 'brd-left')}>
                                        <Title>{t('special')}</Title>
                                        <strong style={{fontSize:20}}>{price(setting.current_special_price)} {currencySymbol}</strong>
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item size={{xs:12,md:6}}  className="bg-gray-box p-20">
                                <SubTitle style={{marginBottom:20}}><strong>{t('myStocks')}</strong></SubTitle>
                                {
                                    data.stocks.map((stock,index) => (
                                        <Box className="flex-space" style={{background: "#e9eae9", padding:10, marginBottom:5 ,borderRadius:8}}>
                                            <div className="d-flex" style={{gap:10}}>
                                                <Typography className='font-12 color-gray-number' style={{backgroundColor:"#fff"}}>{index + 1}</Typography>
                                                <Typography className="font-13">{stock.number}</Typography>
                                            </div>
                                            <Typography className="font-13">{stock.type === "normal" ? t('normalStock') : t('specialStock')  }</Typography>
                                        </Box>
                                    ))
                                }
                                {
                                    data.stocks?.length === 0 ?
                                    <div className='text-center d-flex flex-column mt-20' style={{alignItems:'center', gap:20}}>
                                        <CircleOff className='lucide-icon-gray lucide-xl'/>
                                        <Typography className="font-13">{t('YouDontHaveStock')}</Typography>
                                        <Typography className="font-13">{t('YouDontHaveStockContinue')}</Typography>
                                    </div>
                                        :
                                       <div className="text-center mt-10">
                                           <Button
                                               color="secondary"
                                               variant="outlined"
                                               size="small"
                                               component={Link}
                                               to={'/stocks/view-all'}
                                           >
                                               {t('viewAll')}
                                           </Button>
                                       </div>
                                }
                            </Grid>
                            <Grid item size={{xs:12,md:6}}>
                                <Box className="bg-gray-box chart" style={{height:'100%'}}>
                                    <SubTitle style={{marginBottom:20}}><strong>{t('stockProfitChart')}</strong></SubTitle>
                                    <ProfitsChart />
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,md:6}} >
                                <Box className="bg-gray-box chart" style={{height:'100%'}}>
                                    <SubTitle style={{marginBottom:20}}><strong>{t('stockPriceChart')}</strong></SubTitle>
                                    <StockPriceChart/>
                                </Box>
                            </Grid>
                        </>


                }
            </Grid>
        </AppAnimate>

    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mstp)(UserDashboard));
